import { Loader } from "@albelli/arc-3-react/lib/Loader/Loader";
import { requestConfig } from "application/config/configActions";
import { requestLocale } from "application/locale/localeActions";
import { requestMenu } from "application/menu/menuActions";
import { useChannel } from "components/_hooks/useChannel";
import { InjectIntlContext } from "components/_hooks/useIntl";
import { useHistory, useLocation } from "components/_hooks/useRouter";
import { globalObject } from "helpers/globalObject";
import { isFinished, isLoading } from "helpers/requestStateHelper";
import React, { useEffect } from "react";
import { addLocaleData, IntlProvider } from "react-intl";
import de from "react-intl/locale-data/de";
import en from "react-intl/locale-data/en";
import fr from "react-intl/locale-data/fr";
import nb from "react-intl/locale-data/nb";
import nl from "react-intl/locale-data/nl";
import sv from "react-intl/locale-data/sv";
import { useDispatch, useSelector } from "react-redux";

export const Bootstrap = ({ children }) => {
  const channel = useChannel();
  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();
  const locale = useSelector(state => state.locale);
  const config = useSelector(state => state.config);
  const menu = useSelector(state => state.menu);

  useEffect(() => {
    dispatch(requestConfig());

    addLocaleData([...en, ...nl, ...de, ...fr, ...nb, ...sv]); // is used for Date localization

    if (!globalObject.disableTracking) {
      history.block((location, action) => {
        globalObject.trackingHelper.trackNavigation(location.pathname);
      });
    }
  }, []);

  useEffect(() => {
    if (isFinished(channel)) {
      const locale = channel && channel.Vendor ? channel.Vendor.Locale : "en-GB";
      dispatch(requestLocale(locale));
      document.documentElement.lang = locale;
    }
  }, [channel]);

  useEffect(() => {
    if (isFinished(config)) dispatch(requestMenu());
  }, [config]);

  const loading = isLoading(locale) || isLoading(config) || isLoading(menu) || isLoading(channel);
  const localeMessages = locale.localeMessages || {};
  if (loading || !localeMessages || !menu.items) {
    return <Loader />;
  }
  return (
    <IntlProvider locale={locale.localeId} messages={localeMessages} location={location} textComponent={React.Fragment}>
      <InjectIntlContext>{children}</InjectIntlContext>
    </IntlProvider>
  );
};
